import { useState } from 'react'
import { api } from '../lib/api'
import { useToast } from './Toast'

interface Props {
  onClose: () => void
  onChange: () => void
}

export default function AiSummaryPanel({ onClose, onChange }: Props) {
  const toast = useToast()
  const [days, setDays] = useState(7)
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  async function run() {
    setLoading(true)
    try {
      const res = await api.aiSummary(days)
      setResult(res.result)
      onChange()
    } catch (e) {
      toast.show(e instanceof Error ? e.message : 'AI 失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="overlay" onClick={onClose}>
      <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">
          <h2>🤖 AI 趋势总结</h2>
          <button className="close-btn" onClick={onClose} aria-label="关闭">
            ×
          </button>
        </div>

        {!result ? (
          <>
            <p className="settings-hint">基于最近 N 天的记录生成趋势总结，仅作观察参考，不提供医学建议。</p>
            <div className="days-selector">
              {[3, 7, 14, 30].map((d) => (
                <button
                  key={d}
                  className={`days-btn ${days === d ? 'active' : ''}`}
                  onClick={() => setDays(d)}
                >
                  {d} 天
                </button>
              ))}
            </div>
            <button className="btn-primary" onClick={run} disabled={loading}>
              {loading ? 'AI 思考中...' : '生成总结'}
            </button>
            <p className="ai-disclaimer">⚠️ 非医学诊断，请咨询专业医生</p>
          </>
        ) : (
          <>
            <div className="ai-result">
              {result.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
            <button className="btn-secondary" onClick={() => setResult(null)}>
              重新生成
            </button>
            <p className="ai-disclaimer">⚠️ 非医学诊断，请咨询专业医生</p>
          </>
        )}
      </div>
    </div>
  )
}
